import { render, staticRenderFns } from "./CoinHistoryModal.vue?vue&type=template&id=590e849d&scoped=true&"
import script from "./CoinHistoryModal.vue?vue&type=script&lang=js&"
export * from "./CoinHistoryModal.vue?vue&type=script&lang=js&"
import style0 from "./CoinHistoryModal.vue?vue&type=style&index=0&id=590e849d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590e849d",
  null
  
)

export default component.exports